import { render, staticRenderFns } from "./LayoutsList.vue?vue&type=template&id=d5c3f6c4&scoped=true&"
import script from "./LayoutsList.vue?vue&type=script&lang=js&"
export * from "./LayoutsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c3f6c4",
  null
  
)

export default component.exports